import './confirmation-popup.scss'
import { FC, useState } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { InputSwitch } from "primereact/inputswitch"
import { useDispatch, useSelector } from 'react-redux'
import { createUser, updateUser } from 'features/authentication/userSlices'
import { useFormik } from 'formik'
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import * as Yup from "yup";
import { strict } from 'assert'

interface ConfirmationPopupProps {
  wordToConfirm: string;
  setWordToConfirm: Function;
  fncOnConfirm: Function;
  fncArgs: any;
  actionText: string;
  actionDetail: string;
}
interface UserFormProps{
  word: string;
}

const ConfirmationPopup : FC<ConfirmationPopupProps>= ({wordToConfirm, setWordToConfirm, fncOnConfirm, fncArgs, actionText, actionDetail}) => {
    const user = useSelector((state: any) => state.auth.user);
    const users = useSelector((state: any) => state.user.users);
    const connectedUserFromTable = users.find(u => u.id == user.id)
    const dispatch: Function = useDispatch();
    
    const validationSchema = Yup.object().shape({
      word: Yup.string()
        .required('This field is required')
        .oneOf([wordToConfirm], 'Word must be exactly '+ wordToConfirm)
    });

    const formik = useFormik<UserFormProps>({
      initialValues:{
        word: ''
      },
      validateOnMount: true,
      validationSchema,
      onSubmit: () =>{
        dispatch(fncOnConfirm(fncArgs))
        setWordToConfirm(null)
      }
    });

    const handleClose = () =>{
      formik.resetForm()
      setWordToConfirm(null)
    }
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`confirmation-popup ${wordToConfirm ? 'visible' : ''}`}>
          <div className="confirmation-popup__header">
            <div className="confirmation-popup__header__titles">
              <div className="confirmation-popup__header__titles__title">{actionText}</div>
            </div>
            <Button onClick={() =>handleClose()} icon="pi pi-times" iconPos='right' className="confirmation-popup__header__close-button" />
          </div>
          
          {/* value={generalFormik.values.email} type='string' name={'email'} onChange={generalFormik.handleChange} */}
          <div className="confirmation-popup__content">
          <div className="confirmation-popup__content__warning">{actionDetail}</div>
            <div className="confirmation-popup__content__title">{`Please type ${wordToConfirm} to confirm`}</div>
            <InputText name="word" value={formik.values.word} onChange={formik.handleChange} placeholder={wordToConfirm}/>
            
          </div>
          <div className="confirmation-popup__footer">
            <Button onClick={() => handleClose()} iconPos='right' label={'Cancel'} className="confirmation-popup__footer__cancel-button" />
            <Button onClick={() => formik.handleSubmit()} iconPos='right' disabled={!formik.isValid} label={'Confirm'} className="confirmation-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default ConfirmationPopup